import queryString from 'query-string';

import { PERMISSIONS } from '@/lib/permissions/socialPermissions';
import { OAUTH_NETWORKS } from '@/lib/routes/privateRoutes';

export const getOauthUrl = (socialProfileNetwork, redirectUrl) => {
    const url = OAUTH_NETWORKS[socialProfileNetwork] ?? OAUTH_NETWORKS.facebook;
    return `${url}?${queryString.stringify(
        {
            redirect_to: encodeURIComponent(redirectUrl),
            permissions: [PERMISSIONS.SCHEDULER]
        },
        { arrayFormat: 'bracket' }
    )}`;
};
